import { Portal, Spinner, Stack, Toast, Toaster as ChakraToaster } from '@chakra-ui/react'

import { toaster } from './toaster'

/** Rendered once by AppProviders; reads from the shared toast queue. */
export const Toaster = () => (
  <Portal>
    <ChakraToaster toaster={toaster} insetInline={{ mdDown: '4' }} gap="2">
      {(toast) => (
        <Toast.Root
          width={{ md: '20rem' }}
          bg="surface.raised"
          color="text.primary"
          borderWidth="1px"
          borderColor="border.default"
          borderRadius="md"
          boxShadow="md"
          padding="3"
          gap="2.5"
          alignItems="flex-start"
        >
          {toast.type === 'loading' ? (
            <Spinner size="sm" color="brand.solid" borderWidth="2px" />
          ) : (
            <Toast.Indicator boxSize="4" marginTop="0.5" />
          )}

          <Stack gap="0.5" flex="1" maxWidth="100%">
            {toast.title && <Toast.Title textStyle="label">{toast.title}</Toast.Title>}
            {toast.description && (
              <Toast.Description textStyle="helperText">{toast.description}</Toast.Description>
            )}
          </Stack>

          {toast.action && <Toast.ActionTrigger>{toast.action.label}</Toast.ActionTrigger>}
          {toast.closable && <Toast.CloseTrigger />}
        </Toast.Root>
      )}
    </ChakraToaster>
  </Portal>
)
